const cilentType = {
    state: {
        deptName: "部门",
        deptNameTip: "请选择部门",
        deptUserNo: "工号",
        deptUserNoTip: "请输入工号",
        dept: "部门信息"
        // collegeName: "学院",
        // collegeNameTip: "请选择学院",
        // collegeUserNo: "学号",

    },
    mutations: {
        deptOrCollegeName(state, deptName) {
            state.deptName = deptName;
        },
        deptOrCollegeTip(state, deptNameTip) {
            state.deptNameTip = deptNameTip;
        },
        deptOrCollegeNo(state, deptUserNo) {
            state.deptUserNo = deptUserNo;
        },
        deptOrCollegeNoTip(state, deptUserNoTip) {
            state.deptUserNoTip = deptUserNoTip;
        },
        deptOrCollege(state, dept) {
            state.dept = dept;
        },
    }

};
export default cilentType



// WEBPACK FOOTER //
// ./src/store/modules/cilentType.js